<template>
  <v-overlay :model-value="loadingStore.loadingStatus" class="align-center justify-center">
    <v-progress-circular color="primary" size="64" indeterminate></v-progress-circular>
  </v-overlay>
</template>

<script lang="ts">
import { useLoadingStore } from '~/stores/loading';
export default defineComponent({
  data() {
    return {
      loadingStore: useLoadingStore(),
    }
  },

  created() {

  },
  methods: {

  },
})
</script>

<style></style>